export class Topup
{
    store_id: string;
    amount: string;    
    createdby: string;   
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/topupmodel.ts